import { gql, useMutation } from "@apollo/client";

export const MUTATION_IMPORT_KARAPIT = gql`
  mutation importKarapitContent(
    $username: String!
    $encryptedPassword: String!
    $files: [String!]!
    $study: String!
    $targetFolder: String!
    $activityId: ID!
    $qualityCheckStatus: QualityCheckStatus
    $description: String
  ) {
    importKarapitContent(
      input: {
        username: $username
        encryptedPassword: $encryptedPassword
        study: $study
        files: $files
        targetFolder: $targetFolder
        activityId: $activityId
        qualityCheckStatus: $qualityCheckStatus
        description: $description
      }
    )
  }
`;

export function useImportKarapit() {
  const [
    importContentMutation,
    {
      data: karapitImportMutationData,
      loading: isLoadingKarapitMutation,
      error: errorKarapitMutation
    }
  ] = useMutation(MUTATION_IMPORT_KARAPIT, {
    onError(err: any) {
      console.log(err);
    }
  });

  return {
    importContentMutation,
    karapitImportMutationData,
    isLoadingKarapitMutation,
    errorKarapitMutation
  };
}
